// Reading window.localStorage throws a SecurityError when the document is denied storage
// (blocked cookies or site data), so every access, the property read included, sits inside
// the guard. Reads degrade to null and writes to a no-op.

export const readLocalStorage = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export const writeLocalStorage = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value)
  } catch {}
}

export const removeFromLocalStorage = (key: string): void => {
  try {
    window.localStorage.removeItem(key)
  } catch {}
}
